export const Delete = (props) => {
  const { hover } = props;

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27 14C27 6.82292 21.1771 1 14 1C6.82292 1 1 6.82292 1 14C1 21.1771 6.82292 27 14 27C21.1771 27 27 21.1771 27 14Z"
        stroke="#3948FF"
        fill={hover ? "#3948FF" : undefined}
        strokeWidth="1.5"
        strokemiterlimi="10"
      />
      <path
        d="M18.3346 18.3327L9.66797 9.66602"
        stroke={hover ? "white" : "#3948FF"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.66797 18.3327L18.3346 9.66602"
        stroke={hover ? "white" : "#3948FF"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
